/*
 * Carlyle Avenue PDP Shop Pay installments
 * ---------------------------------------------------------------------------
 * Keeps the installments widget's variant in sync on `variant:update` (matters
 * for variant-priced products) by updating the hidden form's id input and the
 * <shopify-payment-terms> variant-id attribute.
 *
 * Vanilla JS, no dependencies. IIFE + page-level init guard. Variant event
 * contract is `variant:update` with detail.resource = the full variant object.
 */
(function () {
  if (window.__caInstallmentsInit) return;
  window.__caInstallmentsInit = true;

  document.addEventListener('variant:update', function (event) {
    var resource = event.detail && event.detail.resource;
    if (!resource) return;
    var scope = (event.target.closest && event.target.closest('.shopify-section')) || document;
    var roots = scope.querySelectorAll('[data-ca-installments]');
    for (var i = 0; i < roots.length; i++) {
      var idInput = roots[i].querySelector('input[name="id"]');
      if (idInput) idInput.value = resource.id;
      var terms = roots[i].querySelector('shopify-payment-terms');
      if (terms) terms.setAttribute('variant-id', resource.id);
    }
  });
})();
